import getAkamaiHeaderValue from './getAkamaiHeaderValue.js';
import CookieHelper from '../CookieHelper.js';

/**
 * Akamai Header utility
 *
 * getZipCode
 * Will return zip code from Akamai cookie.
 * if zip code from cookie is empty, will return zip code from Akamai cookie.
 *
 */
const zipPattern = /\b(zip=)([0-9]{5})/ig;
const AKAMAI_COOKIE = 'x-coxauto-aka-data';

const getAkamaiZipCode = requestHeader => {
    try {
        const akamaiLocationData = CookieHelper.get(AKAMAI_COOKIE);

        if (akamaiLocationData) {
            const decodedLocationData = decodeURI(akamaiLocationData);
            const akamaiSplit = decodedLocationData.split('|');
            const akamaiZip = akamaiSplit[2];

            if (akamaiZip && akamaiZip.length === 5) {
                return akamaiZip;
            }
            return '';
        }

        return getAkamaiHeaderValue(requestHeader, zipPattern);
    } catch (error) {
        return '';
    }

}

export { getAkamaiZipCode }